

import { apiGet, apiPost } from '../../API/httpCommon';
import { useEffect, useState } from 'react';
import { ProductModel } from '../../Model/ProductModel';
import config from '../../config.json';
import { debug } from 'console';
import Spinner from '../Spinner/Spinner';
import {AddUpdateCart,GetCart} from  '../../Utility/CartUtility';
import { useLocation, useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

const ProductList = () =>{

   const navigate = useNavigate();   
 const { cid, category } = useParams();

 const [ProductCategoryList, setProductCategoryList] = useState<ProductModel[]>([]);

 const [CategoryProductList, setCategoryProductList] = useState<ProductModel[]>([]);
 const [DescriptionDetails,setDescriptionDetails] = useState<any>();
 const [SpecificationList,setSpecificationList] = useState<any>();

 const [isLoading, setIsLoading] = useState(false);
 const [CategoryId,setCategoryId] = useState<number>(0);

 const [StartIndex,setStartIndex] = useState(0);
 const [PageSize,setPageSize] = useState(44);
 const [SpecificationParamModel, setSpecificationParamModel] = useState<any>([]);
 const [Orderby,setOrderby] = useState(1);
 
 const [ShowViewMore,setShowViewMore] = useState(false);

 const[CategoryTree, setCategoryTree] = useState<any>([]);

 const location = useLocation();

    useEffect(function () {

        getProductByCategory('Engineering Books');
        const userAgent = navigator.userAgent;
        
        let _cid: any = cid?.replace("cid-", '');
        setCategoryId(parseInt(_cid));
        GetCategoryProduct(parseInt(_cid), Orderby, 0, SpecificationParamModel,false);
        getCreateTreee(_cid);
    }, [])


    const getCreateTreee = (categoryId: any) => {
        //setIsLoading(true);
        apiGet(`api/ProductDetails/GetCategoryTree?CategoryId=${categoryId}`).then((res: any) => {
            
            setCategoryTree(res?.Data);
         //setIsLoading(false);
    });
}

 const getProductByCategory = (category: any) => {
        //setIsLoading(true);
        apiGet(`api/Home/GetProductByCategory?Category=${encodeURIComponent(category)}`).then((res: any) => {
        setProductCategoryList(res?.Data);
        //setIsLoading(false);
    });
}


const GetCategoryProduct = (_CategoryId : any, _Orderby : any, _startindex : any, _SpecificationParamModel : any, isFilter : boolean) => {

    

    setIsLoading(true);

    var data = {
        CategoryId : _CategoryId, 
        Orderby : _Orderby,
        startindex : _startindex,
        pagesize : PageSize,
        SpecificationParamModel : _SpecificationParamModel
    }

    apiPost(`api/ProductDetails/GetCategoryProduct`,data).then((res: any) => {
     
    if(isFilter){
        setCategoryProductList(res?.Data?.CategoryProductList);
    }
    else{
        setCategoryProductList(prevData => [...prevData, ...res?.Data?.CategoryProductList]);
    }
    
    setDescriptionDetails(res?.Data?.DescriptionDetails);
    setSpecificationList(res?.Data?.SpecificationList);
    setIsLoading(false);
    setStartIndex(_startindex+1);
    if(res?.Data?.CategoryProductList?.length < PageSize){
        setShowViewMore(false);
    }
    else{
        setShowViewMore(true);
    }



});
}

const addToCart = (actionType : any, _Item_Id : any, _Item_Title : any, _Quantity : any, _Seller_Price : any, _Seller_Id : any, _Item_Title_Url : any) =>{
    const response  =  AddUpdateCart(actionType , _Item_Id , _Item_Title , _Quantity , _Seller_Price, _Seller_Id, 0, _Item_Title_Url);
     $("#CartText").text(GetCart().length);
     navigate('/Cart');

 }

  const  handleSpecification = (event : any, item : any, ShortName : any) =>{
    
    let val = {
        Short_Name : ShortName,
        Specification_Value : item.Values
    }
    let  isChecked : any =   event.target.checked;
         if(isChecked){
            let arr : any[] = SpecificationParamModel;
            arr.push(val);
            setSpecificationParamModel(arr);
            GetCategoryProduct(CategoryId, Orderby , 0, arr,true);
         }
         else{
             let filteredData : any[] =  SpecificationParamModel?.filter((x : any )=> !(x?.Short_Name ===  ShortName && x?.Specification_Value === item.Values));
             setSpecificationParamModel(filteredData);
             GetCategoryProduct(CategoryId, Orderby , 0, filteredData,true);

         }
  }



    return(<>
    
    {(isLoading && <Spinner></Spinner>)} 

   
    <div className=" breadcrumb-padding-180"></div>
    {/* <!-- Breadcumb Section Start --> */}
    <div className="breadcrumb-wrapper">
   
        <div className="container">
            <div className="page-heading">
				<h3>START EXPLORING</h3>
                <h3>{DescriptionDetails?.Category_Name}</h3>
                 {/* <div className="form-clt wow fadeInUp" data-wow-delay=".9s">
                                <button type="submit" className="theme-btn btn2">
                                    Shop Now <i className="fa-solid fa-arrow-right-long"></i>
                                </button>
                            </div> */}
            </div>
        </div>
    </div>


    {/* <!-- Shop Section Start --> */}
    <section className="shop-section fix section-padding">
        <div className="container">
            <div className="shop-default-wrapper">
                <div className="row">
                   
                    <div className="col-xl-3 col-lg-4 order-2 order-md-1 wow fadeInUp" data-wow-delay=".3s">
                        <div className="main-sidebar">
                         
                            <div className="single-sidebar-widget">
							
							  <div className="wid-title">
                                    <h5>{DescriptionDetails?.Category_Name} Categories</h5>
                                </div>
                              
							<div id="trust" className="tab-pane fade show active" role="tabpanel">
                                <div className="faq-content">
								
                                    <div className="faq-accordion">
                                        <div className="accordion" id="accordion">
										
                                            <div className="accordion-item mb-3">
                                                <h5 className="accordion-header">
                                                    <button className="accordion-button collapsed" type="button"
                                                        data-bs-toggle="collapse" data-bs-target="#Books"
                                                        aria-expanded="true" aria-controls="Books">
                                                      {DescriptionDetails?.Category_Name}
                                                    </button>
                                                </h5>
                                                <div id="Books" className="accordion-collapse collapse show"
                                                    data-bs-parent="#accordion">
                                                    <div className="accordion-body  categoryOverflow">
                                                       <ul className="list">
                                                        {
                                                            CategoryTree?.map( (x : any )=>(
                                                                <li data-value="1" className="option selected">
                                                              <a href={"/" +x.Category_Name_Url+"/cid-"+x.Category_Id}> {x.Category_Name}</a> 
                                                            </li>
                                                            ))
                                                        }
                                            </ul>
                                                    </div>
                                                </div>
                                            </div>
                                                    {
                                                        SpecificationList?.map((item: any) => (

                                                            <div className="accordion-item mb-3">
                                                                <h5 className="accordion-header">
                                                                    <button className="accordion-button collapsed" type="button"
                                                                        data-bs-toggle="collapse" data-bs-target={`#Filter${item?.ShortName}`}
                                                                        aria-expanded="false" aria-controls={`Filter${item?.ShortName}`}>
                                                                        {item?.ShortName}
                                                                    </button>
                                                                </h5>
                                                                <div id={`Filter${item?.ShortName}`} className="accordion-collapse collapse"
                                                                    data-bs-parent="#accordion">
                                                                    <div className="accordion-body">
                                                                        {
                                                                            item?.Values?.map((val : any)=>(
                                                                                <div className="form-check-2 d-flex align-items-center from-customradio-2">
                                                                                <input className="form-check-input" onChange={(e) =>handleSpecification(e,val,item?.ShortName)} type="checkbox" name="2024" /> &nbsp;
                                                                                <label className="form-check-label">{(val.Values + '(' +val.Counts+')' )}</label>
                                                                                </div>
                                                                            ))
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))
                                                    }
                                           
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                               
                                

                            </div>
                           
                            
                        </div>
                    </div>
                    <div className="col-xl-9 col-lg-8 order-1 order-md-2">
                           
                                <div className="row">

                                {CategoryProductList?.map(item => (
                                    <div className="col-xl-3 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay=".2s">
                                       <div className="shop-box-items style-2">
											<div className="book-thumb center">
                                                <a href={"/" + item?.Item_Title_Url + "-" + item?.Item_Id}><img src={config?.ThumbImageBaseUrl + item?.Image_Link} alt="img" /></a>
											   
												
											</div>
                                            <div className="shop-content">
												<h3><a href={"/" + item?.Item_Title_Url + "-" + item?.Item_Id}>{item?.Item_Title}</a></h3>
											    {item?.Release_Date && item.Category_Name !== 'Home Store' && 	<h5> Publish Year: {item?.Release_Date} </h5>}
												<ul className="price-list">
                                                <li>Price: {item?.Seller_Price}</li>
                                                <li>
                                                    <del>₹ {item?.Base_Price}</del>
                                                </li>
                                            </ul>
											</div>
                                            <div className="shop-button">
                                            <a  className="theme-btn crtbtn" onClick={() => addToCart('Add',item?.Item_Id, item?.Item_Title,1,item?.Seller_Price, item.Seller_Id,item.Item_Title_Url)} ><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                            <a className="theme-btn crtbtn"  onClick={() => addToCart('Add',item?.Item_Id, item?.Item_Title,1,item?.Seller_Price, item.Seller_Id,item.Item_Title_Url)}><i className="fa-solid fa-list"></i> Buy Now</a>
                                        </div>

										</div>
                                    </div>
                                    ))}

                                </div>
                       
                       { ShowViewMore &&  <div className="page-nav-wrap text-center">
                            <ul>
                                <li><a className="previous" onClick={()=>GetCategoryProduct(CategoryId, Orderby , StartIndex, SpecificationParamModel,false)} >View More</a></li>
                            </ul>
                        </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    </section>
    
    {/* <!-- Shop Section start  --> */}
	
	<section className="shop-section section-padding fix">
        <div className="container">
              <div className="section-title-area">
                <div className="section-title">
                    <h2 className="wow fadeInUp" data-wow-delay=".3s">Explore Catagories</h2>
                </div>
            </div>
				<div className="row">
					<div className="col-md-3">
						<div className="book-shop-wrapper">
							<div className="cta-shop-box text-center" style={{background:"#adddb9"}}>
								<h6 className="wow fadeInUp" data-wow-delay=".4s"><i>START EXPLORING</i></h6>
								<h2 className="wow fadeInUp" data-wow-delay=".2s">
									TAXATION<br/>
									BOOKS
								</h2>
								 <img src="/assets/img//taxataion.webp" alt="shape-img" style={{width: "90px", marginBottom:"10px"}}/><br/>
								<a href="/Taxation-Books/cid-10029" className="theme-btn white-bg wow fadeInUp" data-wow-delay=".6s" style={{background:"#5e17eb", color:"#ffffff"}}>View More <i
										className="fa-solid fa-arrow-right-long"></i></a>
								
							</div>
						</div>
					</div>
					<div className="col-md-6">
						<div className="book-shop-wrapper">
							<div className="cta-shop-box text-center" style={{background:"#f7a072"}}>
								<div className="row">
									<div className="col-md-8">
										<h6 className="wow fadeInUp" data-wow-delay=".4s"><i>START EXPLORING</i></h6>
										<h2 className="wow fadeInUp" data-wow-delay=".2s">
											LEGAL
											BOOKS
										</h2>
									</div>
									<div className="col-md-4">
										<a href="/Legal-Books/cid-10031" className="theme-btn white-bg wow fadeInUp" data-wow-delay=".6s">View More <i
										className="fa-solid fa-arrow-right-long"></i></a>
									</div>
								</div>
							</div>
						</div>
						<div className="book-shop-wrapper">
							<div className="cta-shop-box text-center" style={{background:"#ffa857"}}>
								<div className="row">
									<div className="col-md-4">
										<a href="/Science/cid-11280" className="theme-btn white-bg wow fadeInUp" data-wow-delay=".6s">View More <i
										className="fa-solid fa-arrow-right-long"></i></a>
									</div>
									<div className="col-md-8">
										<h6 className="wow fadeInUp" data-wow-delay=".4s"><i>START EXPLORING</i></h6>
										<h2 className="wow fadeInUp" data-wow-delay=".2s">
											SCIENCE
											BOOKS
										</h2>
									</div>
									
								</div>
							
								
							</div>
						</div>
					</div>
					<div className="col-md-3">
						<div className="book-shop-wrapper">
							<div className="cta-shop-box text-center" style={{background:"#d7eaf8"}}>
								<h6 className="wow fadeInUp" data-wow-delay=".4s"><i>START EXPLORING</i></h6>
								<h2 className="wow fadeInUp" data-wow-delay=".2s">
									MEDICAL<br/>
									BOOKS
								</h2>
								 <img src="/assets/img//medical.webp" alt="shape-img" style={{width: "100px", marginBottom :"10px"}}/><br/>
								<a href="/Medical-Books/cid-10002" className="theme-btn white-bg wow fadeInUp" data-wow-delay=".6s" style={{background:"#5e17eb", color:"#ffffff"}}>View More <i
										className="fa-solid fa-arrow-right-long"></i></a>
								
							</div>
						</div>
					</div>
				</div>
                

                
            
        </div>
    </section>


    <section className="shop-section section-padding fix  book-catagories-section">
            <div className="container">
                <div className="section-title-area">
                    <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist" style={{ margin: "0 auto" }}>
                        <li className="nav-item" role="presentation">
                            <button className="nav-link active" id="pills-Engineering-tab" data-bs-toggle="pill"
                                type="button" role="tab"
                                aria-controls="pills-Engineering" aria-selected="true" onClick={() => getProductByCategory('Engineering Books')}>Engineering Books</button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button className="nav-link" id="pills-Math-tab" data-bs-toggle="pill"
                                data-bs-target="#pills-Math" type="button" role="tab"
                                aria-controls="pills-Math" aria-selected="false" onClick={() => getProductByCategory('Mathematics & Statistics Books')}>Mathematics & Statistics Books</button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button className="nav-link " id="pills-Management-tab" data-bs-toggle="pill"
                                data-bs-target="#pills-Management" type="button" role="tab"
                                aria-controls="pills-Management" aria-selected="false"  onClick={() => getProductByCategory('Management')}>Management</button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button className="nav-link" id="pills-UPSC-tab"
                                data-bs-toggle="pill" data-bs-target="#pills-UPSC"
                                type="button" role="tab" aria-controls="pills-UPSC"
                                aria-selected="false"   onClick={() => getProductByCategory('UPSC / PCS')}>UPSC / PCS </button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button className="nav-link" id="pills-Nursing-tab" data-bs-toggle="pill"
                                data-bs-target="#pills-Nursing" type="button" role="tab"
                                aria-controls="pills-Nursing" aria-selected="false" onClick={() => getProductByCategory('Nursing Books')}>Nursing Books</button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button className="nav-link" id="pills-Kids-tab" data-bs-toggle="pill"
                                data-bs-target="#pills-Kids" type="button" role="tab"
                                aria-controls="pills-Kids" aria-selected="false"  onClick={() => getProductByCategory('Kids Books')}>Kids Books</button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button className="nav-link" id="pills-Travel-tab" data-bs-toggle="pill"
                                data-bs-target="#pills-Travel" type="button" role="tab"
                                aria-controls="pills-Travel" aria-selected="false" onClick={() => getProductByCategory('Travel Books')}>Travel Books</button>
                        </li>
                    </ul>
                </div>
                <div className="array-button">
                    <button className="array-prev"><i className="fal fa-arrow-left"></i></button>
                    <button className="array-next"><i className="fal fa-arrow-right"></i></button>
                </div>

                <div className="swiper book-slider ">
                    <div className="swiper-wrapper">

                        {
                            ProductCategoryList?.map(item => (

                                <div className="swiper-slide">
                                    <div className="shop-box-items style-2">
                                        <div className="book-thumb center">
                                            <a href={"/" + item?.Item_Title_Url + "-" + item?.Item_Id}><img src={config?.ThumbImageBaseUrl + item?.Image_Link} alt="img" /></a>

                                           
                                        </div>
                                        <div className="shop-content">
                                            <h3><a href="#">{item?.Item_Title}</a></h3>
                                            <h5> Publish Year:{item?.Release_Date} </h5>
                                            <ul className="price-list">
                                                <li>Price: ₹{item?.Seller_Price}</li>
                                                <li>
                                                    <del>₹{item?.Base_Price}</del>
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="shop-button">

                                          

                                            {
                                                (item?.Stock_Status === "PreOrder" || item?.Stock_Status === "In Stock" ||
                                                    item?.Stock_Status === "In Stock" || item?.Stock_Status === "Avaliable") && (
                                                    <>
                                                        <a onClick={() => addToCart('Add', item?.Item_Id, item?.Item_Title, 1, item?.Seller_Price, item.Seller_Id, item?.Item_Title_Url)} className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                                        <a onClick={() => addToCart('Add', item?.Item_Id, item?.Item_Title, 1, item?.Seller_Price, item.Seller_Id, item?.Item_Title_Url)} className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>

                                                    </>)
                                            }

                                                {
                                                    (item?.Stock_Status === "Permanently Discountinued" || item?.Stock_Status === "Termprory Unavailable" ||
                                                        item?.Stock_Status === "Out of Stock") && (
                                                        <>
                                                            <span>{item?.Stock_Status}</span>
                                                        </>)
                                                }


                                        </div>
                                    </div>
                                </div>
                            ))
                        }

                    </div>
                </div>




            </div>
        </section>
        
        </>);
}

export default ProductList;